import React, { useEffect, useState } from "react";
import { getMyCapstoneProject, getCapstoneDownloadUrl } from "../../services/capstoneProjectService";
import "../datatable/datatable.scss";

export const MyCapstoneProject = () => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMyCapstoneProject = async () => {
    try {
      const data = await getMyCapstoneProject();
      setProject(data.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyCapstoneProject();
  }, []);

  const downloadProjectFile = async () => {
    try {
      const res = await getCapstoneDownloadUrl(project.studentId);
      window.open(res.data?.downloadUrl, "_blank");
    } catch (err) {
      console.error("Error fetching download URL:", err);
      alert("Failed to fetch download link.");
    }
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="datatable">
      <h2 className="datatableTitle">My Capstone Project</h2>

      {project?.shareToStudent && project?.originalFilename ? (
        <div>
          <p>{project.originalFilename}</p>
          <button onClick={downloadProjectFile}>Download</button>
        </div>
      ) : (
        <p>Your capstone project has not been shared yet.</p>
      )}
    </div>
  );
};
